import(/* webpackMode: "eager", webpackExports: ["default"] */ "/source/node_modules/@mui/icons-material/esm/Close.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/source/node_modules/@mui/material/Dialog/Dialog.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/source/node_modules/@mui/material/IconButton/IconButton.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/source/src/common-components-src/components/UKCounter/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/source/src/common-components-src/components/UKToast/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/source/src/common-components-src/js/gift/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default","getInstance"] */ "/source/src/common-components-src/js/newlogin/index.newlogin.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/source/src/components/headerFooterWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GiftModal"] */ "/source/src/lib/jdiClientUtils.ts");
;
import(/* webpackMode: "eager", webpackExports: ["ProductLayoutWrapper"] */ "/source/src/styles/product/index.ts");
